import { createAuthProvider, getIdpHintChoiceAuthConfig, IDPHint } from '@newfront-insurance/next-auth';

import { getNovaMountedPath } from '@/client/lib/nova-mount-path';
import { getConfig } from '@/config';

const { API, KEYCLOAK } = getConfig();

export const AuthProvider = createAuthProvider({
  ...getIdpHintChoiceAuthConfig([IDPHint.GSUITE, IDPHint.ENTRAID]),
  idpHintChoiceUri: getNovaMountedPath('/auth/idp-choice'),
  authApiConfig: {
    clientId: KEYCLOAK.CLIENT_ID,
    realm: KEYCLOAK.REALM.EMPLOYEES,
    url: API.AUTH,
  },
});
